// TabButton.tsx
import React from "react";
import { TabButtonProps } from "../types/revenue.types";

export const TabButton: React.FC<TabButtonProps> = ({
  active,
  onClick,
  icon,
  label,
  colorTheme,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "12px 24px",
        background: "transparent",
        border: "none",
        fontSize: "16px",
        fontWeight: active ? "600" : "500",
        color: active ? colorTheme.primary : colorTheme.gray600,
        cursor: "pointer",
        borderBottom: active
          ? `3px solid ${colorTheme.primary}`
          : "3px solid transparent",
        transition: "all 0.2s",
      }}
    >
      {icon} {label}
    </button>
  );
};
